var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSingleCapture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 26,
    viewBox: "0 0 33 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5439 5.23888C17.8562 2.03461 24.88 0.827594 26.6527 1.03964L26.8599 2.08398L26.5285 2.02689C24.921 1.72217 17.1283 2.6896 9.85722 6.78605C8.93127 7.30752 7.87284 8.02377 6.89772 8.76987C5.83486 9.60316 2.4872 12.5283 2.16895 14.2253C2.68105 10.9131 7.71988 7.1803 11.5439 5.23888Z",
    fill: "#16A665"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8516 10.3963C27.8516 10.3963 27.6332 11.7884 27.3792 12.965C26.3631 13.8165 23.8899 15.4046 21.5732 16.2226C21.3974 14.9758 20.6133 14.6604 19.8278 13.7551C18.5557 12.2899 18.8422 11.2016 20.53 10.9618C25.5687 10.2486 26.7779 8.66041 27.8499 7.01333C29.7814 4.05041 29.2541 1.38623 29.2541 1.38623C32.0016 6.16184 27.0469 11.1554 25.4709 12.4722C25.6142 12.3716 26.551 11.7549 27.8506 10.3974L27.8516 10.3963Z",
    fill: "#16A665"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8337 5.10037C21.7444 4.951 20.4072 5.77913 20.3879 7.06453C19.9784 7.2962 20.657 6.88874 20.3877 7.06453C20.3879 7.55822 21.1388 8.07557 21.3479 8.52022C22.1963 8.54766 21.9355 8.28388 22.4659 7.88454H22.4669C22.4669 7.88454 22.0116 8.07339 21.2251 8.32031C21.4649 8.95335 21.6997 9.90967 22.0178 10.1474C23.2331 11.0518 24.366 9.39246 24.4809 8.07557C24.6424 6.26891 24.114 5.27615 22.8337 5.09935V5.10037Z",
    fill: "#16A665"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3159 16.5937H21.4932C21.7259 16.5033 21.9586 16.4088 22.1923 16.3092C27.4155 14.0929 31.8654 9.6827 32.8603 6.33643C33.2769 9.45813 30.7109 13.787 27.3149 16.5937H27.3159Z",
    fill: "#16A665"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5011 1.52734C29.5011 1.52734 31.9705 2.03048 32.6534 3.86966C34.0668 7.67707 28.1367 11.9783 28.1367 11.9783C28.1367 11.9783 33.1726 7.33972 31.8618 4.29948C31.3334 3.07302 29.9584 2.69588 29.9584 2.69588L29.5011 1.52734Z",
    fill: "#16A665"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4993 23.5251C6.25645 23.8699 5.91649 24.461 6.06257 25.2985C4.04793 24.7087 2.26714 22.6558 1.97537 22.0793C-0.0167706 18.1435 2.63793 13.8078 8.15938 10.73C3.4989 13.6632 1.36542 17.2166 2.70947 20.2111C3.35513 21.6504 4.58732 23.1264 6.4993 23.5251Z",
    fill: "#16A665"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.67124 26.0002C7.39253 26.0002 7.97725 25.4155 7.97725 24.6942C7.97725 23.9729 7.39253 23.3882 6.67124 23.3882C5.94995 23.3882 5.36523 23.9729 5.36523 24.6942C5.36523 25.4155 5.94995 26.0002 6.67124 26.0002Z",
    fill: "url(#paint0_linear_1297_10827)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.87768 25.2362C6.87768 25.3502 6.78512 25.4428 6.67224 25.4428C6.55936 25.4428 6.4668 25.3502 6.4668 25.2362C6.4668 25.1222 6.55936 25.0308 6.67224 25.0308C6.78512 25.0308 6.87768 25.1233 6.87768 25.2362Z",
    fill: "url(#paint1_linear_1297_10827)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.67254 25.1165C6.77187 25.1165 6.8554 25.1877 6.87572 25.2814C6.87911 25.2678 6.88024 25.2531 6.88024 25.2385C6.88024 25.1245 6.78768 25.0308 6.67254 25.0308C6.5574 25.0308 6.46484 25.1233 6.46484 25.2385C6.46484 25.2531 6.46597 25.2678 6.46936 25.2814C6.48855 25.1877 6.57208 25.1165 6.67254 25.1165Z",
    fill: "url(#paint2_linear_1297_10827)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.17726 25.1444C6.15243 25.2302 6.06212 25.2788 5.97634 25.2539C5.89055 25.2291 5.84201 25.1388 5.86684 25.053C5.89168 24.9672 5.98198 24.9187 6.06777 24.9435C6.15356 24.9683 6.20209 25.0586 6.17726 25.1444Z",
    fill: "url(#paint3_linear_1297_10827)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.05081 25.0067C6.12531 25.0282 6.17159 25.1004 6.16595 25.1749C6.17159 25.1647 6.17498 25.1546 6.17837 25.1444C6.2032 25.0586 6.15466 24.9683 6.06887 24.9435C5.98309 24.9187 5.89391 24.9672 5.86795 25.053C5.86456 25.0643 5.8623 25.0744 5.8623 25.0857C5.8973 25.0191 5.97518 24.9853 6.04968 25.0067L6.05081 25.0067Z",
    fill: "url(#paint4_linear_1297_10827)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M5.65635 24.9163C5.63604 24.984 5.57169 25.0246 5.51187 25.0066C5.45204 24.9885 5.41931 24.9196 5.43963 24.8519C5.45994 24.7842 5.52429 24.7436 5.58411 24.7616C5.64394 24.7797 5.67667 24.8485 5.65635 24.9163Z",
    fill: "url(#paint5_linear_1297_10827)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M5.56905 24.8124C5.62097 24.8282 5.65258 24.8824 5.64581 24.9411C5.64919 24.9332 5.65258 24.9253 5.65597 24.9163C5.67628 24.8485 5.64355 24.7797 5.58372 24.7616C5.5239 24.7436 5.45956 24.7842 5.43924 24.8519C5.43698 24.8609 5.43472 24.8688 5.43359 24.8779C5.46068 24.8248 5.516 24.7966 5.56792 24.8113L5.56905 24.8124Z",
    fill: "url(#paint6_linear_1297_10827)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.17431 25.1449C7.19914 25.2307 7.28944 25.2792 7.37523 25.2544C7.46102 25.2296 7.50956 25.1393 7.48472 25.0535C7.45989 24.9677 7.36959 24.9192 7.28493 24.944C7.19914 24.9688 7.1506 25.0591 7.17544 25.1449L7.17431 25.1449Z",
    fill: "url(#paint7_linear_1297_10827)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.30104 25.0072C7.22654 25.0286 7.18026 25.1009 7.1859 25.1754C7.18026 25.1652 7.17687 25.1551 7.17348 25.1449C7.14865 25.0591 7.19719 24.9688 7.28298 24.944C7.36876 24.9192 7.45794 24.9677 7.4839 25.0535C7.48729 25.0648 7.48954 25.0749 7.48954 25.0862C7.45455 25.0196 7.37666 24.9858 7.30216 25.0072L7.30104 25.0072Z",
    fill: "url(#paint8_linear_1297_10827)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.68572 24.9163C7.70604 24.984 7.77038 25.0246 7.8302 25.0066C7.89003 24.9885 7.92277 24.9196 7.90245 24.8519C7.88213 24.7842 7.81779 24.7436 7.75796 24.7616C7.69814 24.7797 7.6654 24.8485 7.68572 24.9163Z",
    fill: "url(#paint9_linear_1297_10827)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.77264 24.8124C7.72071 24.8282 7.68911 24.8824 7.69588 24.9411C7.69249 24.9332 7.68911 24.9253 7.68572 24.9163C7.6654 24.8485 7.69814 24.7797 7.75796 24.7616C7.81779 24.7436 7.88213 24.7842 7.90245 24.8519C7.9047 24.8609 7.90696 24.8688 7.90809 24.8779C7.881 24.8248 7.82569 24.7966 7.77377 24.8113L7.77264 24.8124Z",
    fill: "url(#paint10_linear_1297_10827)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.82997 24.4721C6.82997 24.5613 6.75773 24.6347 6.66743 24.6347C6.57713 24.6347 6.50488 24.5624 6.50488 24.4721C6.50488 24.3818 6.57713 24.3096 6.66743 24.3096C6.75773 24.3096 6.82997 24.3818 6.82997 24.4721Z",
    fill: "url(#paint11_linear_1297_10827)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.66773 24.3773C6.74675 24.3773 6.81222 24.4326 6.82689 24.5071C6.82915 24.4958 6.83028 24.4845 6.83028 24.4732C6.83028 24.3829 6.75691 24.3096 6.6666 24.3096C6.5763 24.3096 6.50293 24.3829 6.50293 24.4732C6.50293 24.4845 6.50406 24.4958 6.50632 24.5071C6.52212 24.4326 6.58759 24.3773 6.66548 24.3773L6.66773 24.3773Z",
    fill: "url(#paint12_linear_1297_10827)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.27855 24.4057C6.25823 24.4734 6.18825 24.5118 6.12052 24.4914C6.05279 24.4711 6.01442 24.4011 6.03473 24.3334C6.05505 24.2657 6.12504 24.2273 6.19276 24.2476C6.26049 24.2679 6.29887 24.3379 6.27855 24.4057Z",
    fill: "url(#paint13_linear_1297_10827)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.17717 24.2983C6.23587 24.3153 6.27312 24.3717 6.26747 24.4304C6.27199 24.4225 6.27537 24.4146 6.27763 24.4056C6.29795 24.3378 6.25957 24.2667 6.19184 24.2475C6.12412 24.2272 6.05413 24.2667 6.03381 24.3333C6.03155 24.3424 6.0293 24.3503 6.0293 24.3593C6.05752 24.3074 6.11847 24.2803 6.17717 24.2972L6.17717 24.2983Z",
    fill: "url(#paint14_linear_1297_10827)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M5.87051 24.2203C5.85471 24.2733 5.80391 24.3049 5.7565 24.2914C5.70909 24.2778 5.68426 24.2225 5.70006 24.1695C5.71587 24.1164 5.76666 24.0848 5.81407 24.0983C5.86148 24.1119 5.88631 24.1672 5.87051 24.2203Z",
    fill: "url(#paint15_linear_1297_10827)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M5.80337 24.1379C5.84401 24.1503 5.86884 24.1932 5.86433 24.2394C5.86771 24.2338 5.86997 24.227 5.87223 24.2203C5.88803 24.1672 5.86207 24.1119 5.81579 24.0983C5.76838 24.0848 5.71758 24.1164 5.70178 24.1695C5.69952 24.1762 5.69839 24.183 5.69727 24.1898C5.71871 24.148 5.76274 24.1254 5.80337 24.1379Z",
    fill: "url(#paint16_linear_1297_10827)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.06501 24.4042C7.08533 24.4719 7.15531 24.5103 7.22304 24.49C7.29077 24.4697 7.32914 24.3997 7.30883 24.3319C7.28851 24.2642 7.21852 24.2258 7.1508 24.2462C7.08307 24.2665 7.04469 24.3365 7.06501 24.4042Z",
    fill: "url(#paint17_linear_1297_10827)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.16547 24.2969C7.10677 24.3138 7.06952 24.3702 7.07517 24.4289C7.07065 24.421 7.06727 24.4131 7.06501 24.4041C7.04469 24.3364 7.08307 24.2653 7.1508 24.2461C7.21852 24.2258 7.28851 24.2653 7.30883 24.3319C7.31108 24.3409 7.31334 24.3488 7.31334 24.3578C7.28512 24.3059 7.22417 24.2788 7.16547 24.2957L7.16547 24.2969Z",
    fill: "url(#paint18_linear_1297_10827)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.47506 24.2203C7.49086 24.2733 7.54166 24.3049 7.58907 24.2914C7.63648 24.2778 7.66131 24.2225 7.64551 24.1695C7.6297 24.1164 7.57891 24.0848 7.5315 24.0983C7.48409 24.1119 7.45926 24.1672 7.47393 24.2203L7.47506 24.2203Z",
    fill: "url(#paint19_linear_1297_10827)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.54518 24.1379C7.50454 24.1503 7.47971 24.1932 7.48422 24.2394C7.48084 24.2338 7.47858 24.227 7.47632 24.2203C7.46052 24.1672 7.48648 24.1119 7.53276 24.0983C7.58017 24.0848 7.63097 24.1164 7.64677 24.1695C7.64903 24.1762 7.65016 24.183 7.65128 24.1898C7.62984 24.148 7.58581 24.1254 7.54518 24.1379Z",
    fill: "url(#paint20_linear_1297_10827)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.78338 23.8892C6.78338 23.9513 6.73258 24.0021 6.6705 24.0021C6.60841 24.0021 6.55762 23.9513 6.55762 23.8892C6.55762 23.8272 6.60841 23.7764 6.6705 23.7764C6.73258 23.7764 6.78338 23.8272 6.78338 23.8892Z",
    fill: "url(#paint21_linear_1297_10827)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.67163 23.8238C6.72694 23.8238 6.77209 23.8622 6.78338 23.9141C6.7845 23.9062 6.78563 23.8983 6.78563 23.8904C6.78563 23.8272 6.73484 23.7764 6.67163 23.7764C6.60841 23.7764 6.55762 23.8272 6.55762 23.8904C6.55762 23.8983 6.55762 23.9062 6.55988 23.9141C6.57116 23.8622 6.61631 23.8238 6.67163 23.8238Z",
    fill: "url(#paint22_linear_1297_10827)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.39668 23.8393C6.38314 23.8867 6.33347 23.9127 6.28606 23.8991C6.23865 23.8856 6.21269 23.8359 6.22624 23.7885C6.23978 23.7411 6.28945 23.7151 6.33686 23.7287C6.38427 23.7422 6.41023 23.7919 6.39668 23.8393Z",
    fill: "url(#paint23_linear_1297_10827)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.3265 23.7636C6.36714 23.776 6.3931 23.8144 6.38972 23.8561C6.3931 23.8505 6.39536 23.8449 6.39649 23.8392C6.41004 23.7918 6.38407 23.7421 6.33666 23.7286C6.28926 23.715 6.24072 23.7421 6.22604 23.7884C6.22378 23.7941 6.22266 23.8008 6.22266 23.8065C6.24185 23.7704 6.28474 23.7512 6.3265 23.7636Z",
    fill: "url(#paint24_linear_1297_10827)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.11213 23.7175C6.10084 23.7547 6.06585 23.7773 6.03311 23.7671C6.00038 23.757 5.98232 23.7197 5.9936 23.6825C6.00489 23.6452 6.03988 23.6226 6.07262 23.6328C6.10535 23.643 6.12341 23.6802 6.11213 23.7175Z",
    fill: "url(#paint25_linear_1297_10827)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.06443 23.6599C6.09265 23.6689 6.11071 23.6983 6.10732 23.731C6.10958 23.7265 6.11184 23.722 6.11297 23.7175C6.12426 23.6802 6.1062 23.6418 6.07346 23.6328C6.04073 23.6226 6.0046 23.6452 5.99444 23.6825C5.99332 23.687 5.99219 23.6915 5.99219 23.6971C6.00686 23.6678 6.03734 23.652 6.06669 23.661L6.06443 23.6599Z",
    fill: "url(#paint26_linear_1297_10827)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.94303 23.8388C6.95658 23.8862 7.00625 23.9122 7.05365 23.8986C7.10106 23.8851 7.12703 23.8354 7.11348 23.788C7.09993 23.7406 7.05027 23.7146 7.00286 23.7282C6.95545 23.7417 6.92949 23.7914 6.94303 23.8388Z",
    fill: "url(#paint27_linear_1297_10827)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.01302 23.7631C6.97238 23.7755 6.94642 23.8139 6.94981 23.8557C6.94642 23.85 6.94416 23.8444 6.94303 23.8387C6.92949 23.7913 6.95545 23.7416 7.00286 23.7281C7.05027 23.7146 7.09881 23.7416 7.11348 23.7879C7.11574 23.7936 7.11687 23.8003 7.11687 23.806C7.09768 23.7699 7.05478 23.7507 7.01302 23.7631Z",
    fill: "url(#paint28_linear_1297_10827)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.23286 23.7184C7.24415 23.7557 7.27914 23.7783 7.31188 23.7681C7.34461 23.758 7.36267 23.7207 7.35138 23.6835C7.3401 23.6462 7.3051 23.6236 7.27237 23.6338C7.23963 23.6439 7.22157 23.6812 7.23286 23.7184Z",
    fill: "url(#paint29_linear_1297_10827)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.2814 23.6609C7.25318 23.6699 7.23512 23.6993 7.23851 23.732C7.23625 23.7275 7.23399 23.723 7.23286 23.7184C7.22157 23.6812 7.23963 23.6428 7.27237 23.6338C7.3051 23.6236 7.34123 23.6462 7.35138 23.6835C7.35251 23.688 7.35364 23.6925 7.35364 23.6981C7.33897 23.6688 7.30849 23.653 7.27914 23.662L7.2814 23.6609Z",
    fill: "url(#paint30_linear_1297_10827)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.51662 24.7754C6.51662 24.8612 6.44664 24.9312 6.36085 24.9312C6.27506 24.9312 6.20508 24.8612 6.20508 24.7754C6.20508 24.6896 6.27506 24.6196 6.36085 24.6196C6.44664 24.6196 6.51662 24.6896 6.51662 24.7754Z",
    fill: "url(#paint31_linear_1297_10827)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.36198 24.6851C6.43761 24.6851 6.50082 24.7382 6.5155 24.8093C6.51775 24.7991 6.51888 24.7878 6.51888 24.7765C6.51888 24.6896 6.4489 24.6196 6.36198 24.6196C6.27506 24.6196 6.20508 24.6896 6.20508 24.7765C6.20508 24.7878 6.20621 24.798 6.20846 24.8093C6.22314 24.7382 6.28635 24.6851 6.36198 24.6851Z",
    fill: "url(#paint32_linear_1297_10827)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.14065 24.7778C7.14065 24.8636 7.07066 24.9336 6.98487 24.9336C6.89909 24.9336 6.8291 24.8636 6.8291 24.7778C6.8291 24.6921 6.89909 24.6221 6.98487 24.6221C7.07066 24.6221 7.14065 24.6921 7.14065 24.7778Z",
    fill: "url(#paint33_linear_1297_10827)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.986 24.6875C7.06163 24.6875 7.12484 24.7406 7.13952 24.8117C7.14178 24.8015 7.1429 24.7903 7.1429 24.779C7.1429 24.6921 7.07292 24.6221 6.986 24.6221C6.89909 24.6221 6.8291 24.6921 6.8291 24.779C6.8291 24.7903 6.83023 24.8004 6.83249 24.8117C6.84716 24.7406 6.91037 24.6875 6.986 24.6875Z",
    fill: "url(#paint34_linear_1297_10827)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M5.98264 24.6977C5.96345 24.7621 5.89685 24.7982 5.83251 24.7801C5.76817 24.761 5.73205 24.6944 5.75124 24.63C5.77043 24.5657 5.83703 24.5296 5.90137 24.5476C5.96571 24.5668 6.00183 24.6334 5.98264 24.6977Z",
    fill: "url(#paint35_linear_1297_10827)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M5.88524 24.5954C5.94168 24.6124 5.97667 24.6654 5.97103 24.7219C5.97441 24.7151 5.9778 24.7072 5.98006 24.6981C5.99925 24.6338 5.962 24.5661 5.89879 24.548C5.83444 24.5288 5.76785 24.5661 5.74866 24.6304C5.7464 24.6383 5.74527 24.6474 5.74414 24.6553C5.77123 24.6056 5.8288 24.5796 5.88524 24.5966L5.88524 24.5954Z",
    fill: "url(#paint36_linear_1297_10827)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M5.59441 24.5382C5.57861 24.5901 5.52894 24.6217 5.48379 24.6081C5.43864 24.5946 5.41268 24.5415 5.42848 24.4896C5.44428 24.4377 5.49395 24.4061 5.5391 24.4196C5.58538 24.4332 5.61021 24.4862 5.59441 24.5382Z",
    fill: "url(#paint37_linear_1297_10827)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M5.52655 24.458C5.56718 24.4693 5.59089 24.5122 5.58637 24.5574C5.58976 24.5517 5.59202 24.5449 5.59428 24.5382C5.61008 24.4862 5.58524 24.4332 5.53896 24.4196C5.49268 24.4061 5.44302 24.4377 5.42721 24.4896C5.42496 24.4964 5.42383 24.5032 5.42383 24.5099C5.44415 24.4693 5.48704 24.4467 5.52768 24.4591L5.52655 24.458Z",
    fill: "url(#paint38_linear_1297_10827)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.36499 24.6968C7.38418 24.7611 7.45078 24.7972 7.51512 24.7792C7.57946 24.76 7.61559 24.6934 7.59752 24.629C7.57946 24.5647 7.51174 24.5286 7.4474 24.5466C7.38306 24.5658 7.34693 24.6324 7.36499 24.6968Z",
    fill: "url(#paint39_linear_1297_10827)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.46218 24.5944C7.40574 24.6114 7.37075 24.6644 7.37639 24.7209C7.373 24.7141 7.36962 24.7062 7.36736 24.6972C7.34817 24.6328 7.38542 24.5651 7.44863 24.547C7.51297 24.5279 7.57957 24.5651 7.59876 24.6294C7.60102 24.6373 7.60215 24.6464 7.60328 24.6543C7.57618 24.6046 7.51862 24.5786 7.46218 24.5956L7.46218 24.5944Z",
    fill: "url(#paint40_linear_1297_10827)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.75465 24.5382C7.77045 24.5901 7.82012 24.6217 7.86527 24.6081C7.91155 24.5946 7.93638 24.5415 7.92058 24.4896C7.90478 24.4377 7.85511 24.4061 7.80996 24.4196C7.76481 24.4332 7.73885 24.4862 7.75465 24.5382Z",
    fill: "url(#paint41_linear_1297_10827)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.82054 24.458C7.7799 24.4693 7.75619 24.5122 7.76071 24.5574C7.75732 24.5517 7.75507 24.5449 7.75281 24.5382C7.737 24.4862 7.76184 24.4332 7.80812 24.4196C7.8544 24.4061 7.90407 24.4377 7.91987 24.4896C7.92213 24.4964 7.92326 24.5032 7.92326 24.5099C7.90294 24.4693 7.86004 24.4467 7.81941 24.4591L7.82054 24.458Z",
    fill: "url(#paint42_linear_1297_10827)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.43688 24.2449C6.50234 24.2449 6.5554 24.1918 6.5554 24.1263C6.5554 24.0609 6.50234 24.0078 6.43688 24.0078C6.37142 24.0078 6.31836 24.0609 6.31836 24.1263C6.31836 24.1918 6.37142 24.2449 6.43688 24.2449Z",
    fill: "url(#paint43_linear_1297_10827)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.43801 24.0575C6.49558 24.0575 6.54412 24.0981 6.5554 24.1523C6.55653 24.1444 6.55766 24.1365 6.55766 24.1275C6.55766 24.0609 6.50461 24.0078 6.43801 24.0078C6.37141 24.0078 6.31836 24.0609 6.31836 24.1275C6.31836 24.1354 6.31836 24.1444 6.32062 24.1523C6.33191 24.0981 6.38044 24.0575 6.43801 24.0575Z",
    fill: "url(#paint44_linear_1297_10827)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.91149 24.2449C6.97695 24.2449 7.03001 24.1918 7.03001 24.1263C7.03001 24.0609 6.97695 24.0078 6.91149 24.0078C6.84603 24.0078 6.79297 24.0609 6.79297 24.1263C6.79297 24.1918 6.84603 24.2449 6.91149 24.2449Z",
    fill: "url(#paint45_linear_1297_10827)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.91067 24.0575C6.96824 24.0575 7.01677 24.0981 7.02806 24.1523C7.02919 24.1444 7.03032 24.1365 7.03032 24.1275C7.03032 24.0609 6.97727 24.0078 6.91067 24.0078C6.84407 24.0078 6.79102 24.0609 6.79102 24.1275C6.79102 24.1354 6.79102 24.1444 6.79327 24.1523C6.80456 24.0981 6.8531 24.0575 6.91067 24.0575Z",
    fill: "url(#paint46_linear_1297_10827)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.14693 24.0702C6.13225 24.1187 6.08146 24.147 6.03179 24.1323C5.98325 24.1176 5.95503 24.0668 5.96971 24.0171C5.98438 23.9686 6.03518 23.9404 6.08371 23.9551C6.13225 23.9697 6.16047 24.0205 6.1458 24.0702L6.14693 24.0702Z",
    fill: "url(#paint47_linear_1297_10827)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.07223 23.9923C6.11512 24.0047 6.14109 24.0454 6.1377 24.0882C6.14109 24.0826 6.14334 24.077 6.14447 24.0702C6.15915 24.0217 6.13093 23.9697 6.08239 23.9551C6.03385 23.9404 5.98193 23.9686 5.96725 24.0183C5.965 24.025 5.96387 24.0307 5.96387 24.0375C5.98419 23.9991 6.02821 23.9799 6.0711 23.9923L6.07223 23.9923Z",
    fill: "url(#paint48_linear_1297_10827)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M5.84759 23.9467C5.8363 23.9862 5.79792 24.0099 5.76293 23.9997C5.72793 23.9896 5.70874 23.9489 5.72003 23.9094C5.73132 23.8699 5.7697 23.8462 5.80469 23.8564C5.83968 23.8665 5.85887 23.9071 5.84759 23.9467Z",
    fill: "url(#paint49_linear_1297_10827)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M5.79694 23.8857C5.82742 23.8947 5.84548 23.9263 5.84209 23.9613C5.84435 23.9568 5.84661 23.9523 5.84774 23.9467C5.85902 23.9071 5.84096 23.8665 5.80484 23.8564C5.76985 23.8462 5.73147 23.8699 5.72018 23.9094C5.71905 23.9139 5.71793 23.9196 5.7168 23.9241C5.7326 23.8936 5.76533 23.8767 5.79581 23.8857L5.79694 23.8857Z",
    fill: "url(#paint50_linear_1297_10827)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.19822 24.0702C7.2129 24.1187 7.26369 24.147 7.31223 24.1323C7.36077 24.1176 7.38899 24.0668 7.37431 24.0171C7.35964 23.9686 7.30884 23.9404 7.26031 23.9551C7.21177 23.9697 7.18355 24.0205 7.19822 24.0702Z",
    fill: "url(#paint51_linear_1297_10827)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.27046 23.9923C7.22757 24.0047 7.20161 24.0454 7.20499 24.0882C7.20161 24.0826 7.19935 24.077 7.19822 24.0702C7.18355 24.0217 7.21177 23.9697 7.26031 23.9551C7.30884 23.9404 7.36077 23.9686 7.37544 24.0183C7.3777 24.025 7.37883 24.0307 7.37883 24.0375C7.35851 23.9991 7.31449 23.9799 7.27159 23.9923L7.27046 23.9923Z",
    fill: "url(#paint52_linear_1297_10827)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.49445 23.9467C7.50573 23.9862 7.54411 24.0099 7.57911 23.9997C7.6141 23.9896 7.63329 23.9489 7.622 23.9094C7.61071 23.8699 7.57233 23.8462 7.53734 23.8564C7.50235 23.8665 7.48316 23.9071 7.49445 23.9467Z",
    fill: "url(#paint53_linear_1297_10827)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.5473 23.8857C7.51682 23.8947 7.49876 23.9263 7.50215 23.9613C7.49989 23.9568 7.49763 23.9523 7.49651 23.9467C7.48522 23.9071 7.50328 23.8665 7.5394 23.8564C7.57439 23.8462 7.61277 23.8699 7.62406 23.9094C7.62519 23.9139 7.62632 23.9196 7.62745 23.9241C7.61164 23.8936 7.57891 23.8767 7.54843 23.8857L7.5473 23.8857Z",
    fill: "url(#paint54_linear_1297_10827)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1,
    d: "M1.30601 23.217C0.632122 23.217 0.0790152 22.7068 0.00790149 22.0532C0.00338633 22.0995 -2.04463e-09 22.1469 -3.07927e-09 22.1943C-1.88205e-08 22.9156 0.584713 23.5003 1.30601 23.5003C2.0273 23.5003 2.61202 22.9156 2.61202 22.1943C2.61202 22.1469 2.60976 22.0995 2.60412 22.0532C2.533 22.7079 1.9799 23.217 1.30601 23.217Z",
    fill: "url(#paint55_linear_1297_10827)"
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3438 0.12429C28.9918 0.305948 29.152 1.26956 29.1886 1.78025L29.1912 1.78227C29.2554 2.67817 29.0367 3.95524 29.0367 3.95524C29.0264 3.51066 28.8005 2.83365 28.294 2.60346C27.8742 2.4131 27.37 2.48218 27.0211 2.0608C26.9791 2.01006 26.9429 1.95672 26.9115 1.90194C26.5974 1.19927 26.4441 -0.14 28.3438 0.12429Z",
    fill: "#16A665"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1297_10827",
    x1: 6.67124,
    y1: 23.4096,
    x2: 6.67124,
    y2: 25.9573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FAFCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EFF6FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#DEECFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#C5DEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4DEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1297_10827",
    x1: 6.25571,
    y1: 23.3951,
    x2: 6.56387,
    y2: 24.7576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1297_10827",
    x1: 6.25489,
    y1: 23.3963,
    x2: 6.56418,
    y2: 24.7576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1297_10827",
    x1: 6.04515,
    y1: 24.7582,
    x2: 5.95561,
    y2: 26.1522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1297_10827",
    x1: 6.07715,
    y1: 24.7781,
    x2: 5.98768,
    y2: 26.171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1297_10827",
    x1: 5.5994,
    y1: 24.372,
    x2: 5.54714,
    y2: 25.758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1297_10827",
    x1: 5.58262,
    y1: 24.3653,
    x2: 5.53439,
    y2: 25.7504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1297_10827",
    x1: 7.26621,
    y1: 24.1346,
    x2: 7.35543,
    y2: 25.5275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1297_10827",
    x1: 7.81607,
    y1: 23.9025,
    x2: 7.90279,
    y2: 25.296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1297_10827",
    x1: 7.25684,
    y1: 24.1605,
    x2: 7.30911,
    y2: 25.5465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1297_10827",
    x1: 7.84875,
    y1: 23.9053,
    x2: 7.89729,
    y2: 25.2916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1297_10827",
    x1: 6.41571,
    y1: 23.3569,
    x2: 6.72387,
    y2: 24.7193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1297_10827",
    x1: 6.41488,
    y1: 23.3569,
    x2: 6.72304,
    y2: 24.7182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1297_10827",
    x1: 6.1313,
    y1: 24.7689,
    x2: 6.04207,
    y2: 26.1618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1297_10827",
    x1: 6.16272,
    y1: 24.7888,
    x2: 6.07325,
    y2: 26.1817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1297_10827",
    x1: 5.77615,
    y1: 24.378,
    x2: 5.72389,
    y2: 25.764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1297_10827",
    x1: 5.75849,
    y1: 24.3696,
    x2: 5.71148,
    y2: 25.7549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1297_10827",
    x1: 7.17061,
    y1: 24.1423,
    x2: 7.25983,
    y2: 25.5352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1297_10827",
    x1: 7.72247,
    y1: 23.9122,
    x2: 7.80886,
    y2: 25.3046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1297_10827",
    x1: 7.08359,
    y1: 24.1665,
    x2: 7.13585,
    y2: 25.5525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1297_10827",
    x1: 7.67862,
    y1: 23.9096,
    x2: 7.72716,
    y2: 25.2958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1297_10827",
    x1: 6.54407,
    y1: 23.3339,
    x2: 6.85336,
    y2: 24.6952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1297_10827",
    x1: 6.5452,
    y1: 23.335,
    x2: 6.85336,
    y2: 24.6963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1297_10827",
    x1: 6.25121,
    y1: 24.7761,
    x2: 6.16167,
    y2: 26.1701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1297_10827",
    x1: 6.28223,
    y1: 24.7949,
    x2: 6.19245,
    y2: 26.1889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1297_10827",
    x1: 5.99774,
    y1: 24.3954,
    x2: 5.94548,
    y2: 25.7813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1297_10827",
    x1: 5.98024,
    y1: 24.3868,
    x2: 5.93201,
    y2: 25.7719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1297_10827",
    x1: 7.04829,
    y1: 24.1515,
    x2: 7.13751,
    y2: 25.5445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1297_10827",
    x1: 7.60095,
    y1: 23.9189,
    x2: 7.68767,
    y2: 25.3124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1297_10827",
    x1: 6.8611,
    y1: 24.1838,
    x2: 6.91368,
    y2: 25.5708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1297_10827",
    x1: 7.45528,
    y1: 23.9279,
    x2: 7.50382,
    y2: 25.3141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1297_10827",
    x1: 6.05946,
    y1: 23.4434,
    x2: 6.36762,
    y2: 24.8047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1297_10827",
    x1: 6.05946,
    y1: 23.4446,
    x2: 6.36762,
    y2: 24.8059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1297_10827",
    x1: 6.65301,
    y1: 23.3115,
    x2: 6.96117,
    y2: 24.6729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1297_10827",
    x1: 6.65414,
    y1: 23.3127,
    x2: 6.9623,
    y2: 24.674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1297_10827",
    x1: 5.86189,
    y1: 24.7486,
    x2: 5.77267,
    y2: 26.1415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1297_10827",
    x1: 5.89057,
    y1: 24.7686,
    x2: 5.80079,
    y2: 26.1626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1297_10827",
    x1: 5.52861,
    y1: 24.3732,
    x2: 5.47603,
    y2: 25.7602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1297_10827",
    x1: 5.51287,
    y1: 24.3667,
    x2: 5.46433,
    y2: 25.7529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1297_10827",
    x1: 7.44148,
    y1: 24.0722,
    x2: 7.53102,
    y2: 25.4661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1297_10827",
    x1: 7.97902,
    y1: 23.8503,
    x2: 8.06542,
    y2: 25.2427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_1297_10827",
    x1: 7.34377,
    y1: 24.1293,
    x2: 7.39603,
    y2: 25.5152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_1297_10827",
    x1: 7.91839,
    y1: 23.8832,
    x2: 7.96662,
    y2: 25.2683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_1297_10827",
    x1: 6.27095,
    y1: 23.3926,
    x2: 6.57911,
    y2: 24.7539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_1297_10827",
    x1: 6.27208,
    y1: 23.3926,
    x2: 6.58024,
    y2: 24.7551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_1297_10827",
    x1: 6.72186,
    y1: 23.2899,
    x2: 7.03001,
    y2: 24.6512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_1297_10827",
    x1: 6.72103,
    y1: 23.291,
    x2: 7.03032,
    y2: 24.6524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_1297_10827",
    x1: 6.01392,
    y1: 24.758,
    x2: 5.92438,
    y2: 26.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_1297_10827",
    x1: 6.0424,
    y1: 24.7787,
    x2: 5.95294,
    y2: 26.1716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_1297_10827",
    x1: 5.75029,
    y1: 24.3795,
    x2: 5.69771,
    y2: 25.7665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_1297_10827",
    x1: 5.73345,
    y1: 24.3726,
    x2: 5.68522,
    y2: 25.7577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_1297_10827",
    x1: 7.28809,
    y1: 24.0825,
    x2: 7.37655,
    y2: 25.4768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_1297_10827",
    x1: 7.8247,
    y1: 23.8598,
    x2: 7.91141,
    y2: 25.2533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_1297_10827",
    x1: 7.11618,
    y1: 24.1356,
    x2: 7.16844,
    y2: 25.5215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_1297_10827",
    x1: 7.69353,
    y1: 23.8879,
    x2: 7.74207,
    y2: 25.2742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_1297_10827",
    x1: 1.30601,
    y1: 22.9654,
    x2: 1.30601,
    y2: 23.4473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleCapture);
export default __webpack_public_path__ + "static/media/singleCapture.339f5153e0aefeb5c5e75046c5401eeb.svg";
export { ForwardRef as ReactComponent };